// import { instance, instanceEndUser } from "./service/instance";
import { apiSlice } from '../api/apiSlice'

  export const adminManagementApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAdminManagementList: builder.query<any, any>({
            query: params => {
                return {
                    url: `/ocsp/ocsp-configure`,
                    params: params
                }
            },
            providesTags:['GetAdminManagementList'],
        })
  })
})

export const {
useGetAdminManagementListQuery
} = adminManagementApiSlice;